export const CHANGE_LEVEl_1 = 'MENU_PRTR/changeLevel1';
export const CHANGE_LEVEl_2 = 'MENU_PRTR/changeLevel2';

export const changeLevel1 = (key) => {
  return dispatch => {
    // console.log('changeLevel1: ', key)
    dispatch({type: CHANGE_LEVEl_1, payload: key}); 
  }
}

export const changeLevel2 = (key) => {
  return dispatch => {
    // console.log('changeLevel2: ', key)
    dispatch({type: CHANGE_LEVEl_2, payload: key}); 
  }
}



// WEBPACK FOOTER //
// ./src/@redux/actions/menuPRTRAction.js